import { Flex } from 'antd';
import { BaseHeader } from 'components/header';
import { PrintableRootPage } from 'components/page/page-2';
import { ConcussionRXLogo } from 'features/sign-in/v2/concussionRx-logo';
import { useState } from 'react';
import { LoginForm } from 'features/sign-in/v2/page-sign-in';
import UserRegistrationFormPage from '../_components/form-user_registration';
import RegistrationSteps from '../_components/RegistrationSteps';
import { Link, Subtitle, Text, Title } from 'components/mvp-typography';

export default function UnauthenticatedRegistrationFlow() {
  const currentStep = 0;
  const [showLogin, setShowLogin] = useState(false);
  
  return (
    <PrintableRootPage>
      <BaseHeader
        headerStyle={{
          background: 'none'
        }}
      />

      <Flex align="center" justify="center">
        <ConcussionRXLogo
          style={{ width: 'revert', height: '50px', marginBottom: '20px' }}
        />
      </Flex>
      <RegistrationSteps current={currentStep} />
      <Flex vertical align='center' gap={16}>
      {showLogin ? (
        <Flex vertical align="center" gap={16}>
          <div>
            <Title>Login</Title>
            <Subtitle>Resume your organisation onboarding</Subtitle>
          </div>
          <LoginForm hideLogo />
        </Flex>
      ) : (
        <UserRegistrationFormPage />
      )}

      <Flex vertical justify="center" align="center">
        {showLogin ? (
          <>
            <Text>Don&apos;t have an account?</Text>
            <Link onClick={() => setShowLogin(false)}>Register</Link>
          </>
        ) : (
          <>
            <Text>Already have an account?</Text>
            <Link onClick={() => setShowLogin(true)}>Login</Link>
          </>
        )}
      </Flex>
      </Flex>
    </PrintableRootPage>
  );
}
